import { Text } from '@/shared/ui/Typography'
import { Container } from '@/shared/ui/layouts/CoverLayout/styles'
import Image from 'next/image'
import type { ReactNode } from 'react'

import flashLogoImg from 'public/assets/images/flash-logo-footer.svg'

export type LayoutProps = {
  children: ReactNode
}

export function CoverLayout({ children }: LayoutProps) {
  return (
    <Container>
      {children}
      <footer>
        <Text size="caption1">Realizado por</Text>
        <Image src={flashLogoImg} alt="Flash" width={44} quality={100} />
      </footer>
    </Container>
  )
}
